<div class="container-fluid padding-top-20px">
    <div class="row">
        <div class="container-fluid">
            <div class="fhlb-container">
                <app-breadcrumb *ngIf="showBreadcrumbComp"></app-breadcrumb>
            </div>
            <router-outlet (activate)="componentAdded($event)" (activate)="componentBreadCrumb($event)"></router-outlet>
        </div>
    </div>
</div>